import { Container, Paper, Button, List } from '@mui/material'
import React from 'react'
import { PickingRoute } from '../../../interfaces/Picking/Picking'
import { ListItemWarning } from '../ListItemWarning'
import { useStyles } from '../styles'
import { PickingRouteHeader } from './PickingRouteHeader'

interface PickingNoProductProps {
  pickingRoute?: PickingRoute
  handleEmptying: () => Promise<void>
}

export const PickingNoProduct: React.FC<PickingNoProductProps> = ({
  pickingRoute,
  handleEmptying
}) => {
  const classes = useStyles()
  return (
    <Container maxWidth='xl'>
      <Paper elevation={1} style={{ padding: '15px' }}>
        <PickingRouteHeader pickingRoute={pickingRoute} />

        <List className={classes.alert}>
          <ListItemWarning
            primary='Ruta finalizada'
            secondary='Ya no tiene productos que pickear en esta ruta'
          />
        </List>

        <Button variant='contained' color='primary' onClick={async () => { await handleEmptying();}}>
          Aceptar
        </Button>
      </Paper>
    </Container>
  )
}
